var _rect, _path, _path2, _path3, _g, _path4, _g2, _path5, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRieulIrregular = function SvgRieulIrregular(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 20,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.812 48.1584C49.375 48.0588 49.7507 47.5216 49.6511 46.9586C49.5514 46.3956 49.0143 46.0199 48.4512 46.1195L42.8286 47.1144C42.5124 47.1703 42.2107 46.9594 42.1548 46.6432C42.0989 46.327 42.3098 46.0254 42.626 45.9695L47.6639 45.0781C48.4373 44.9412 48.9533 44.2034 48.8164 43.43L48.4295 41.2432C48.2927 40.4698 47.5548 39.9538 46.7814 40.0906L39.7438 41.3358C39.1981 41.4323 38.834 41.953 38.9306 42.4987C39.0271 43.0444 39.5478 43.4085 40.0935 43.312L45.6064 42.3365C45.8965 42.2852 46.1734 42.4788 46.2247 42.769C46.2761 43.0592 46.0825 43.336 45.7923 43.3874L40.7073 44.2871C39.934 44.4239 39.4179 45.1618 39.5548 45.9352L39.9694 48.2788C40.1063 49.0522 40.8442 49.5682 41.6176 49.4314L48.812 48.1584Z",
    fill: "#DEAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4918 38.4522C57.2107 38.6732 57.9727 38.2695 58.1936 37.5506C58.4146 36.8317 58.0109 36.0697 57.292 35.8488L50.1125 33.6421C49.7088 33.518 49.4821 33.0902 49.6062 32.6865C49.7303 32.2828 50.1582 32.0561 50.5619 32.1802L56.9946 34.1573C57.9822 34.4609 59.0288 33.9064 59.3323 32.9188L60.1905 30.1266C60.4941 29.1391 59.9396 28.0925 58.952 27.7889L49.9659 25.0269C49.2691 24.8128 48.5306 25.204 48.3164 25.9008C48.1023 26.5976 48.4935 27.3361 49.1903 27.5503L56.2296 29.7139C56.6001 29.8278 56.8082 30.2204 56.6943 30.591C56.5804 30.9615 56.1877 31.1695 55.8172 31.0556L49.3243 29.06C48.3368 28.7565 47.2902 29.311 46.9867 30.2985L46.0669 33.291C45.7634 34.2785 46.3179 35.3251 47.3054 35.6287L56.4918 38.4522Z",
    fill: "#DEAAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 12,
    width: 8,
    height: 46
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1725 34.9856C31.1725 47.672 33.6541 57.9716 36.7112 57.9716C37.4773 57.9716 38.2071 57.3253 38.869 56.1606C36.8798 52.6618 35.4842 44.494 35.4842 34.9856C35.4842 25.4772 36.8798 17.3094 38.869 13.8112C38.2071 12.6463 37.4773 12 36.7112 12C33.6541 12 31.1725 22.2996 31.1725 34.9856Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1725 34.9856C31.1725 47.672 33.6541 57.9716 36.7112 57.9716C37.4773 57.9716 38.2071 57.3253 38.869 56.1606C36.8798 52.6618 35.4842 44.494 35.4842 34.9856C35.4842 25.4772 36.8798 17.3094 38.869 13.8112C38.2071 12.6463 37.4773 12 36.7112 12C33.6541 12 31.1725 22.2996 31.1725 34.9856Z",
    fill: "url(#paint0_linear)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 13,
    width: 8,
    height: 44
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4856 56.1611L35.4856 13.8118L42.2476 13.8118L42.2476 56.1611L35.4856 56.1611Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8672 56.1611C36.8795 52.6627 35.4856 44.4946 35.4856 34.9864C35.4856 25.4777 36.8795 17.3102 38.8672 13.8118C40.8561 17.3102 42.2477 25.4777 42.2477 34.9864C42.2477 44.4946 40.8561 52.6627 38.8672 56.1611Z",
    fill: "#8D8D8D"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9267 39.266C28.0989 39.348 29.1156 38.4642 29.1976 37.292C29.2796 36.1198 28.3958 35.103 27.2235 35.0211L15.5173 34.2025C14.859 34.1565 14.3627 33.5855 14.4088 32.9273C14.4548 32.2691 15.0257 31.7728 15.684 31.8188L26.57 32.58C27.9608 32.6773 29.1671 31.6287 29.2643 30.2379L29.6382 24.8905C29.7355 23.4997 28.6869 22.2935 27.2962 22.1962L12.2467 21.1439C11.1106 21.0644 10.1252 21.921 10.0457 23.0572C9.96628 24.1933 10.8229 25.1787 11.959 25.2582L23.4367 26.0608C24.0409 26.103 24.4964 26.627 24.4541 27.2312C24.4119 27.8353 23.8879 28.2908 23.2838 28.2486L12.2997 27.4805C10.909 27.3832 9.7027 28.4318 9.60545 29.8226L9.20869 35.4966C9.11144 36.8873 10.16 38.0936 11.5508 38.1908L26.9267 39.266Z",
    fill: "#DF6D65"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0356,
    y: 42.9507,
    width: 23.9656,
    height: 4.70067,
    rx: 2.03003,
    transform: "rotate(0.427058 12.0356 42.9507)",
    fill: "#DF6D65"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.9186,
    y1: 38.1293,
    x2: 24.3317,
    y2: 32.9196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRieulIrregular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/rieul-irregular.3f8a03c8b695e86887a30ded49ff0f48.blank.svg";